import { useTranslation } from "react-i18next";
import { FaWifi } from "react-icons/fa";
import useOnlineStatus from "../hooks/useOnlineStatus";
import "../styles/OfflineBanner.css";

export default function OfflineBanner() {
  const { t } = useTranslation();
  const online = useOnlineStatus();
  if (online) return null;
  return (
    <div className="offline-banner" role="status">
      <FaWifi className="offline-banner-icon" />
      <span>{t("offline_banner.message")}</span>
    </div>
  );
}
